import { useQuery } from '@tanstack/react-query'
import { ApiRouteEnum } from '../../enums/ApiRouteEnum'
import api from '../api'
import { IAuthOkkSso } from '../../interfaces/entities/IAuthOkkSso'

export const useGetAuthOkkSso = () => {
  return useQuery(
    [ApiRouteEnum.AUTH_OKK_SSO],
    () => api.get<IAuthOkkSso>(ApiRouteEnum.AUTH_OKK_SSO),
    {
      retry: false,
    },
  )
}
